import * as React from "react";
import Box from "@mui/material/Box";

type LogoProps = {
  organizationLogoUrl: string;
  sponsorLogoUrl: string;
};

export default function LogoBar(props: LogoProps) {
  return (
    <div className="grid grid-cols-5 gap-4">
      {props.organizationLogoUrl ? (
        <div className="flex justify-center items-center py-2">
          <Box
            component="img"
            sx={styles.image}
            alt="Organization Logo"
            src={props.organizationLogoUrl}
          />
        </div>
      ) : null}
      <div className="col-span-3"></div>
      {props.sponsorLogoUrl ? (
        <div className="flex justify-center items-center py-2">
          <Box
            component="img"
            sx={styles.image}
            alt="Sponsor Logo"
            src={props.sponsorLogoUrl}
          />
        </div>
      ) : null}
    </div>
  );
}

const styles = {
  image: {
    height: { sm: 100, md: 100 },
    width: { sm: 200, md: 150 },
  },
};
